import {onBlockLoaded} from "@plaudit/frontend-apis";

import "./plaudit-query-loop/popover-support";
import "./plaudit-query-loop/results-count-support";
import {QueryLoopFormImpl} from "./plaudit-query-loop/QueryLoopFormImpl";
import {memoizedCache, PromiseCache} from "../../../lib/utils";

function findNearestFormElement(element: HTMLFormElement|HTMLElement|string): HTMLFormElement {
	if (typeof element === 'string') {
		const possibleElement = document.getElementById(element);
		if (possibleElement === null) {
			throw new Error("Attempt to instantiate a QueryLoopForm instance for a non-form or non-form-related element.");
		}
		element = possibleElement;
	}
	if (element instanceof HTMLFormElement) {
		return element;
	}
	const possibleElement = element.closest('form');
	if (possibleElement === null) {
		throw new Error("Attempt to instantiate a QueryLoopForm instance for a non-form or non-form-related element.");
	}
	return possibleElement;
}

const windowPlauditQueryLoop = ((window as any).plaudit ??= {}).queryLoop ??= {};
if (!("forms" in windowPlauditQueryLoop)) {
	windowPlauditQueryLoop.forms = memoizedCache((form: HTMLFormElement|HTMLElement|string) => new QueryLoopFormImpl(findNearestFormElement(form)),
		form => findNearestFormElement(form).id);

	windowPlauditQueryLoop.fieldTypes = new PromiseCache((field: string|HTMLFieldSetElement) => {
		if (typeof field !== 'string') {
			if (!field.getAttribute('data-tag')) {
				throw new Error("Attempted to initialize a QueryLoopFormField for a fieldset without the necessary data-tag attribute.");
			}
			field = field.getAttribute('data-tag')!;
		}
		field = field.trim();
		if (!field) {
			throw new Error("Attempted to initialize a QueryLoopFormField for a fieldset without the necessary data-tag attribute.");
		}
		return field; // This is now the tag name
	});
	document.dispatchEvent(new Event('plauditQueryLoopAPILoaded'));
}

onBlockLoaded({
	blockOrClassName: "plauditQueryLoop",
	onAdd(element: HTMLElement) {
		if (element instanceof HTMLFormElement) {
			plaudit.queryLoop.forms.get(element);
		}
	}
});
